export default function MatchScoreGauge({ score = 0, label = "Overall Match", testId = "match-score-gauge" }) {
    const safe = Math.max(0, Math.min(100, Math.round(score)));
    const radius = 52;
    const circ = 2 * Math.PI * radius;
    const dash = (safe / 100) * circ;

    return (
        <div
            data-testid={testId}
            className="flex flex-col items-center gap-3"
        >
            <div className="relative flex h-36 w-36 items-center justify-center rounded-full bg-[#0A0A0A] sovereign-shadow">
                <svg width="144" height="144" className="absolute inset-0 -rotate-90">
                    <circle
                        cx="72"
                        cy="72"
                        r={radius}
                        fill="none"
                        stroke="rgba(255,255,255,0.06)"
                        strokeWidth="8"
                    />
                    <circle
                        cx="72"
                        cy="72"
                        r={radius}
                        fill="none"
                        stroke="var(--brand-accent, #C9A96E)"
                        strokeWidth="8"
                        strokeDasharray={`${dash} ${circ}`}
                        strokeLinecap="round"
                        style={{ filter: "drop-shadow(0 0 6px rgba(201,169,110,0.55))", transition: "stroke-dasharray 700ms cubic-bezier(0.22,1,0.36,1)" }}
                    />
                </svg>
                <div className="z-10 flex flex-col items-center">
                    <span className="font-serif text-5xl leading-none" style={{ color: "var(--brand-accent, #C9A96E)" }}>
                        {safe}
                    </span>
                    <span className="caption text-[#737373]">/ 100</span>
                </div>
            </div>
            <div className="caption text-[#A3A3A3]">{label}</div>
        </div>
    );
}
